
import React from 'react';
import { Formik, Form, getIn, ErrorMessage } from 'formik';
import { connect } from 'react-redux';
import InputField from 'components/Input-Field/input-field';
import {
  Box,
  Grid,
  Typography,
} from '@mui/material';
import 'rsuite/dist/rsuite.min.css';
import '../../../../styles/rsuite-component.css';
import CustomSelectField from 'components/Select-Field/custom-select';

const OTRTruck = (props) => {
  const {
    equipment,
    trucks,
    action,
  } = props;

  const getTruckLabel = (item, type) => {
    const id = item.id;
    const primaryText = item.truckNumber;
    const truckType = item.truckType === 'LIVESTOCK' ? 'TRACTOR' : item.truckType;
    const secondaryText = `Type: ${truckType} License: ${item.licensePlate}`;
    const reactSelectObj = {
      id: id,
      label: <Box key={`${type}:${primaryText}`}>
        <Typography variant='body1' fontWeight={600}>{primaryText}</Typography>
        <Typography variant='caption'>{secondaryText}</Typography>
      </Box>,
      value: primaryText
    };
    return reactSelectObj;
  };

  equipment.truck = getTruckLabel(equipment.truck, 'TRUCK');
  const renderTruckForm = (values, errors, touched, setFieldValue, handleBlur, handleChange) => {
    return (
      <Grid container spacing={1}>
        <Grid size={{ xs: 6, sm: 3 }}>
          <Box display='flex'>
            <div style={{ flex: 1 }}>
              <CustomSelectField
                type='TRUCK'
                id='trucks'
                label='Select Truck'
                name='equipment.truck'
                data={trucks.map(b => getTruckLabel(b, 'TRUCK'))}
                value={values.equipment.truck}
                onChange={selected => setFieldValue('equipment.truck', selected)}
              />
              <ErrorMessage name={'equipment.truck'} component={'grid'} style={{ color: '#FF3838' }} />
            </div>
          </Box>
        </Grid>
        <Grid size={{ xs: 6, sm: 3 }}>
          <InputField
            type='text'
            label='Trailer Number'
            name='equipment.trailerNumber'
            value={values.equipment.trailerNumber}
            variant='outlined'
            fullWidth
            error={Boolean(
              getIn(touched, 'equipment.trailerNumber') &&
              getIn(errors, 'equipment.trailerNumber')
            )}
            helperText={Boolean(
              getIn(touched, 'equipment.trailerNumber') &&
              getIn(errors, 'equipment.trailerNumber')
            )}
            onBlur={handleBlur}
            onChange={handleChange}
            margin='dense'
            size='small'
          />
        </Grid>
        <Grid size={{ xs: 4, sm: 2 }}>
          <InputField
            type='text'
            label='Trailer License'
            name='equipment.trailerLicense'
            value={values.equipment.trailerLicense}
            variant='outlined'
            fullWidth
            error={Boolean(
              getIn(touched, 'equipment.trailerLicense') &&
              getIn(errors, 'equipment.trailerLicense')
            )}
            helperText={Boolean(
              getIn(touched, 'equipment.trailerLicense') &&
              getIn(errors, 'equipment.trailerLicense')
            )}
            onBlur={handleBlur}
            onChange={handleChange}
            margin='dense'
            size='small'
          />
        </Grid>
        <Grid size={{ xs: 4, sm: 2 }}>
          <InputField
            type='text'
            label='Trailer Number Hook'
            name='equipment.trailerNumberHook'
            value={values.equipment.trailerNumberHook}
            variant='outlined'
            fullWidth
            error={Boolean(
              getIn(touched, 'equipment.trailerNumberHook') &&
              getIn(errors, 'equipment.trailerNumberHook')
            )}
            helperText={Boolean(
              getIn(touched, 'equipment.trailerNumberHook') &&
              getIn(errors, 'equipment.trailerNumberHook')
            )}
            onBlur={handleBlur}
            onChange={handleChange}
            margin='dense'
            size='small'
            disabled={values.summary.loadType !== 'DROP AND HOOK'}
          />
        </Grid>
        <Grid size={{ xs: 4, sm: 2 }}>
          <InputField
            type='text'
            label='Trailer License Hook'
            name='equipment.trailerLicenseHook'
            value={values.equipment.trailerLicenseHook}
            variant='outlined'
            fullWidth
            error={Boolean(
              getIn(touched, 'equipment.trailerLicenseHook') &&
              getIn(errors, 'equipment.trailerLicenseHook')
            )}
            helperText={Boolean(
              getIn(touched, 'equipment.trailerLicenseHook') &&
              getIn(errors, 'equipment.trailerLicenseHook')
            )}
            onBlur={handleBlur}
            onChange={handleChange}
            margin='dense'
            size='small'
            disabled={values.summary.loadType !== 'DROP AND HOOK'}
          />
        </Grid>
      </Grid>
    );
  };
  return (
    <Formik
      initialValues={{ equipment }}
      enableReinitialize={true}
      onSubmit={(values) => {
      }}
    >
      {({
        errors,
        touched,
        values,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <Form>
          {renderTruckForm(values, errors, touched, setFieldValue, handleBlur, handleChange)}
        </Form>
      )}
    </Formik>
  );
};

function mapStatesToProps(state) {
  // Whatevet is returned will show up as props
  const { trucks } = state.truckReducer;
  return { trucks };
}

export default connect(mapStatesToProps)(OTRTruck);